var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('chartBarras',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loadingGrafica),expression:"loadingGrafica"}],attrs:{"chart":_vm.chart_credito}})}
var staticRenderFns = []

export { render, staticRenderFns }